<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()" *ngIf="!currentUrl">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Contribuição' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ion-card *ngFor="let config of configs" (click)="tratarClick(config)">
    <img [src]="config.imagem | image:' '" />

    <ion-card-content>
      <ion-row>
        <ion-col size="10">
          <div class="titulo" *ngIf="config.tipo == 'CONTRIBUA'">
            {{'Contribuir' | translate}}
          </div>

          <div class="titulo" *ngIf="config.tipo == 'CONTAS_BANCARIAS'">
            {{'Contas bancárias' | translate}}
          </div>

          <div class="titulo" *ngIf="config.tipo == 'MINHAS'">
            {{'Minhas contribuições' | translate}}
          </div>
        </ion-col>

        <ion-col>
          <ion-icon class="icon-cad" name="arrow-forward-outline"></ion-icon>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
  <sem-registro *ngIf="!configs.length"></sem-registro>
</ion-content>
